import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { RadiologiaNuevo } from './RadiologiaNuevo';
import { RadiologiaPrevio } from './RadiologiaPrevio';
import { RadiologiaEditar } from './RadiologiaEditar';
import { Forbidden } from '../../../components';

import styles from '../PacienteConsulta.module.css';

export const Radiologia = () => {

    let { id } = useParams();

    const { permisos } = useSelector(state => state.auth);

    let defaultTab = 4;

    if(permisos.radiologiaCreate){
        defaultTab = 1;
    }else if(permisos.radiologiaRead){
        defaultTab = 2;
    }

    const [tab, setTab] = useState(defaultTab);

    const [radiologiaActual, setRadiologiaActual] = useState({});

    return (
        <>
            <div className="row">
                <div className="col">
                    <div className={styles.tabsSubHeader}>Radiología</div>
                    <div  className={styles.tabsContainerInner + " mt-3"}>
                        <div className={"row"}>
                            {(permisos.radiologiaCreate) &&
                            <div className="col p-0 text-center">
                                <div className={ (tab === 1) ? styles.tabActiveInner : styles.tabInner } onClick={() => setTab(1)}>Nuevo</div>
                            </div>
                            }
                            {(permisos.radiologiaRead && (!permisos.radiologiaUpdate || tab !== 3)) &&
                            <div className="col p-0 text-center">
                                <div className={ (tab === 2) ? styles.tabActiveInner : styles.tabInner } onClick={() => setTab(2)}>Previos</div>
                            </div>
                            }
                            {(permisos.radiologiaUpdate && tab === 3) &&
                            <div className="col p-0 text-center">
                                <div className={ styles.tabActiveInner }>Editar</div>
                            </div>
                            }
                        </div>
                    </div>
                    <div className={styles.tabsContentContainerInner}>
                        { (permisos.radiologiaCreate && tab === 1) && <RadiologiaNuevo id={id} /> }
                        { (permisos.radiologiaRead && tab === 2) && <RadiologiaPrevio id={id} editar={() => setTab(3)} setRadiologiaActual={setRadiologiaActual} /> }
                        { (permisos.radiologiaUpdate && tab === 3) && <RadiologiaEditar id={id} radiologiaData={radiologiaActual} cancelar={() => setTab(2)} /> }
                        { (tab === 4) && <Forbidden /> }
                    </div>
                </div>
            </div>
        </>
    )
}
